// Antd
import { message as AntdMessage } from 'antd';

const message = AntdMessage;
export default message;
